<template>
  <form
    action="/search.html"
    class="search-form"
    method="get"
  >
    <label class="search-form__label">
      <DiscernibleContent>Search</DiscernibleContent>
      <input
        ref="searchInput"
        v-model="fieldValue"
        type="text"
        name="q"
        placeholder="Search"
        class="search-form__input"
        value=""
      >
      <button
        v-if="fieldValue"
        type="reset"
        class="search-form__reset"
        @click="resetSearch"
      >
        <DiscernibleContent>Reset search</DiscernibleContent>
        <svg
          aria-hidden="true"
          class="search-form__reset-icon"
          viewbox="0 0 15.679 15.679"
          xmlns="http://www.w3.org/2000/svg"
        >
          <use xlink:href="/svgs/symbol-close.svg#icon"/>
        </svg>
      </button>
    </label>
    <button
      :disabled="!fieldValue"
      class="search-form__submit base-cta-text"
      type="submit"
    >
      Search
      <span class="base-cta-text__icon-wrap">
        <svg
          aria-hidden="true"
          class="base-cta-text__icon base-cta-text__icon--off"
          viewbox="0 0 28.596 7.778"
          xmlns="http://www.w3.org/2000/svg"
        >
          <use xlink:href="/svgs/symbol-arrow.svg#icon"/>
        </svg>
        <svg
          aria-hidden="true"
          class="base-cta-text__icon base-cta-text__icon--on"
          viewbox="0 0 28.596 7.778"
          xmlns="http://www.w3.org/2000/svg"
        >
          <use xlink:href="/svgs/symbol-arrow.svg#icon"/>
        </svg>
      </span>
    </button>
  </form>
</template>

<script>
export default {
  props: {
    showTerm: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fieldValue: undefined,
    }
  },
  mounted() {
    this.fieldValue = this.showTerm ? this.getUrlParameter() : ''
  },
  methods: {
    resetSearch() {
      this.fieldValue = undefined
      this.$refs.searchInput.focus()
    },
    getUrlParameter() {
      const regex = new RegExp('[\\?&]q=([^&#]*)')
      const results = regex.exec(location.search)
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/SearchForm.vue